import { ImsCostingMethod } from "@redotech/crdb-enums/inventory/ims-costing-method";
import * as z from "zod";

export const getCostLedgerStatus = {
  name: "getCostLedgerStatus" as const,
  input: z.object({}),
  output: z.object({
    method: z
      .enum([ImsCostingMethod.WeightedAverage, ImsCostingMethod.Fifo])
      .nullable(),
  }),
};
